const initialState = {
  articles: [],
  article: null,
  categories: [],
  authenticated: false,
  error: false,
  message: "",
  subscribed: false,
  displayPaymentModal: false,
  flashMessage: { show: false, content: ''}
};

export default initialState;
